module.exports = __webpack_public_path__ + "static/media/battery-three-quarters.6f74a116.svg";